export const courses = [
  {
    id: 1,
    name: "Hackers Library Bundle",
    category: "Cybersecurity",
    instructor: "Security Expert Team",
    duration: "50 hours",
    students: 1250,
    rating: 4.8,
    price: 149,
    originalPrice: 2999,
    image: "/images/products/security/zero-to-mastery.webp",
    description: "Master cybersecurity fundamentals, ethical hacking, and penetration testing with hands-on labs.",
    shortDescription: "Complete cybersecurity Beginner to Advanced Resource Bundle",
    features: [
      "50+ hours of video content",
      "Hands-on labs and exercises",
      "Real-world case studies",
      "Certification preparation",
      "Lifetime access",
      "Quantum cryptography",
      "Graphology & behavioral analysis"
    ],
    level: "Beginner to Advanced",
    isActive: true
  }
];
